import allowedExtensions from '../allowedExtensions';
import isExtensionAllowed from './isExtensionAllowed';
import isFileSizeValid from './isFileSizeValid';

const validateFiles = (files: FileList) => {
    const okFiles: File[] = [];
    const errors: { message: string; data?: Object }[] = [];
    Array.from(files).forEach((file) => {
        const isValidFileSize = isFileSizeValid(file.size);
        if (!isValidFileSize) {
            errors.push({ message: 'File size is limited to 2Gb.' });
        }
        const isValidExtension = isExtensionAllowed(file.name, allowedExtensions);
        if (!isValidExtension) {
            errors.push({
                message: 'File extension is not supported, you can only upload _allowedExtensions_ file.',
                data: { allowedExtensions }
            });
        }
        if (isValidFileSize && isValidExtension) {
            okFiles.push(file);
        }
    });
    return { files: okFiles, errors };
};

export default validateFiles;
